// Język konta (`language` w /profile): w nim aplikacja pokazuje teksty, daty i liczby.
// Stan jest wspólny: ustawia go wczytanie profilu (useMenu), zmiana w Ustawieniach → Profil
// i przełącznik na ekranach logowania. Do wczytania profilu obowiązuje język ostatnio użyty
// na tym urządzeniu, a na nowym — język przeglądarki (pl… → polski, inny → angielski, jak API).
import { computed, ref, watch } from 'vue';
import { i18n } from '@/i18n/index.js';

export const LANGUAGES = [
    { value: 'pl', label: 'Polski' },
    { value: 'en', label: 'English' },
];

// Format dat i liczb dla języka: angielski brytyjski — 24 h, „25 October", tydzień od poniedziałku.
const INTL = { pl: 'pl-PL', en: 'en-GB' };

const KEY = 'rountine.language';
const known = (code) => LANGUAGES.some(l => l.value === code);
const stored = () => { try { return localStorage.getItem(KEY); } catch { return null; } };
const browser = () => {
    const lang = typeof navigator === 'undefined' ? '' : (navigator.language || '');
    return !lang || lang.toLowerCase().startsWith('pl') ? 'pl' : 'en';
};

const current = ref(known(stored()) ? stored() : browser());

// Język, w którym aplikacja się pokazuje (i który zapisuje konto).
export const language = computed(() => current.value);
export const accountLanguage = language;

export const setAccountLanguage = (code) => { if (known(code)) current.value = code; };

// „pl-PL" / „en-GB" — do toLocaleString i Intl.
export const intlLocale = () => INTL[language.value];

const apply = (code) => {
    i18n.global.locale.value = code;
    try { localStorage.setItem(KEY, code); } catch { /* zostaje do końca sesji */ }
};
watch(language, apply, { immediate: true });
